import React from 'react';
import "../../../styles/FlowMastersMob.css";

function FlowMastersMob(props) {
  return (
    <div id="FlowMasters_Mob">
        <div id="FM_24_MoBGroup_14927">
            <img id="FM_24_MoBstyle_3" src="./Themes/FlowMasters/style_3.png" srcset="./Themes/FlowMasters/style_3.png 1x" />
                
            <svg class="FM_24_MoBRectangle_84">
                <rect id="FM_24_MoBRectangle_84" rx="0" ry="0" x="0" y="0" width="91" height="23">
                </rect>
            </svg>
            <div id="FM_24_MoBFlowing_Solutions_for_Every_Pi">
                <span>"Flowing Solutions for Every Pipe Dilemma – Your Trusted Plumbing Partner!"</span>
            </div>
            <div id="FM_24_MoBExplore_Now_">
                <span>Explore Now !</span>
            </div>
            <div id="FM_24_MoBScroll_Group_42">
                <div id="FM_24_MoBintro_part">
                    <span>{props.data.introduction}</span>
                </div>
            </div>
            <img id="FM_24_MoBzane-lee-bXbi1jJVDf0-unsplash_" src={props.data.imageUrl?process.env.REACT_APP_GOOGLEDRIVE_VIEW_IMG+(props.data.imageUrl.split('/')[5]):"./Themes/FlowMasters/zane-lee-bXbi1jJVDf0-unsplash_.png"} />
                
            <div id="FM_24_MoBOperate_Live">
                <span>{props.data.businessName}</span>
            </div>
        </div>
        <div id="FM_24_MoBGroup_15072">
            <div id="FM_24_MoBGroup_15071">
                <img id="FM_24_MoBej-strat-VjWi56AWQ9k-unsplash" src="./Themes/FlowMasters/ej-strat-VjWi56AWQ9k-unsplash.png" srcset="./Themes/FlowMasters/ej-strat-VjWi56AWQ9k-unsplash.png 1x" />
                    
                <div id="FM_24_MoBGroup_15067">
                    <div id="FM_24_MoBScroll_Group_51">
                        <div id="FM_24_MoBElevate_Your_Space_with_Timele">
                            <span>{props.data.vision}</span>
                        </div>
                    </div>
                    <div id="FM_24_MoBVision">
                        <span>Vision</span>
                    </div>
                </div>
            </div>
            <div id="FM_24_MoBGroup_15070">
                <img id="FM_24_MoBsamuel-sianipar-scUBcasSvbE-un" src="./Themes/FlowMasters/samuel-sianipar-scUBcasSvbE-un.png" srcset="./Themes/FlowMasters/samuel-sianipar-scUBcasSvbE-un.png 1x" />
                    
                <div id="FM_24_MoBScroll_Group_79">
                    <div id="FM_24_MoBElevate_Your_Space_with_Timele_bk">
                        <span>{props.data.mission}</span>
                    </div>
                </div>
                <div id="FM_24_MoBMission">
                    <span>Mission</span>
                </div>
            </div>
            <div id="FM_24_MoBGroup_15069">
                <img id="FM_24_MoBkyle-glenn-Qo4gei6NvcQ-unsplas" src="./Themes/FlowMasters/kyle-glenn-Qo4gei6NvcQ-unsplas.png" srcset="./Themes/FlowMasters/kyle-glenn-Qo4gei6NvcQ-unsplas.png 1x" />
                    
                <div id="FM_24_MoBGroup_15068">
                    <div id="FM_24_MoBScroll_Group_80">
                        <div id="FM_24_MoBElevate_Your_Space_with_Timele_bq">
                            <span>{props.data.principles}</span>
                        </div>
                    </div>
                    <div id="FM_24_MoBPrinciples">
                        <span>Principles</span>
                    </div>
                </div>
            </div>
        </div>
        <div id="FM_24_MoBOur_Offerings">
            <span>Our Offerings</span>
        </div>
        <div id="FM_24_MoBScroll_Group_81">
	{props.offeringsData.map((off,idx)=>(
            <div id="FM_24_MoBGroup_15053">
                <img id="FM_24_MoBlucas-van-oort-Cm_APC_oD-w-uns" src={off.defaultOfferingsImageUrl?process.env.REACT_APP_GOOGLEDRIVE_VIEW_IMG+(off.defaultOfferingsImageUrl.split('/')[5]):"./Themes/FlowMasters/lucas-van-oort-Cm_APC_oD-w-uns.png"} />
                    
                <div id="FM_24_MoBGroup_25">
                    <svg class="FM_24_MoBRectangle_72">
                        <rect id="FM_24_MoBRectangle_72" rx="0" ry="0" x="0" y="0" width="251" height="129">
                        </rect>
                    </svg>
                    <svg class="FM_24_MoBRectangle_73">
                        <rect id="FM_24_MoBRectangle_73" rx="0" ry="0" x="0" y="0" width="251" height="2">
                        </rect>
                    </svg>
                    <div id="FM_24_MoBPlumbing">
                        <span>{off.offeringTitle}</span>
                    </div>
                    <div id="FM_24_MoBScroll_Group_68">
                        <div id="FM_24_MoBLorem_ipsum_dolor_sit_amet_con">
                            <span>{off.description}</span>
                        </div>
                    </div>
                </div>
            </div>))}
        </div>
        <div id="FM_24_MoBGroup_15025">
            <div id="FM_24_MoBGroup_15023">
                <div id="FM_24_MoBsocials_grp_shadow_space_websi">
		{props.data.linkedInUrl?
                    <div title="LinkedIn" id="FM_24_MoBlinked_in_grp_shadow_space_web">
                        <svg class="FM_24_MoBmed_shadow_space_website_7">
                            <ellipse id="FM_24_MoBmed_shadow_space_website_7" rx="24" ry="24" cx="24" cy="24">
                            </ellipse>
                        </svg>
                        <div id="FM_24_MoBlinked_in_shadow_space_website">
				<a href={props.data.linkedInUrl} target="_blank">
                            <svg class="FM_24_MoBn_website_7_layout_" viewBox="-15.255 0 15.439 14.566">
                                <path id="FM_24_MoBn_website_7_layout_" d="M -5.594671249389648 3.814697265625e-06 C -8.203055381774902 3.814697265625e-06 -9.837490081787109 1.412798166275024 -10.13955497741699 2.402577638626099 L -10.13955497741699 0.1386871188879013 L -15.2549991607666 0.1386871188879013 C -15.18850803375244 1.3406081199646 -15.2549991607666 14.56553649902344 -15.2549991607666 14.56553649902344 L -10.13955497741699 14.56553649902344 L -10.13955497741699 6.758750915527344 C -10.13955497741699 6.324968814849854 -10.16045379638672 5.891188621520996 -10.02873420715332 5.579627513885498 C -9.676643371582031 4.71206521987915 -8.921167373657227 3.811574220657349 -7.562833309173584 3.811574220657349 C -5.78718090057373 3.811574220657349 -4.979146957397461 5.145845413208008 -4.979146957397461 7.100076198577881 L -4.979146957397461 14.56553649902344 L 0.1837937831878662 14.56553649902344 L 0.1837937831878662 6.543442726135254 C 0.1837937831878662 2.075184345245361 -2.358731746673584 3.814697265625e-06 -5.594671249389648 3.814697265625e-06">
                                </path>
                            </svg>
                        </a>
                            <svg class="FM_24_MoBlinked_in_i_shadow_space_websi" viewBox="0.931 -22.783 4.553 14.427">
                                <path id="FM_24_MoBlinked_in_i_shadow_space_websi" d="M 0.9310000538825989 -8.35551643371582 L 5.484113693237305 -8.35551643371582 L 5.484113693237305 -22.78300476074219 L 0.9310000538825989 -22.78300476074219 L 0.9310000538825989 -8.35551643371582 Z">
                                </path>
                            </svg>
                            <svg class="FM_24_MoBtop_dot_i_shadow_space_website" viewBox="-4.392 0 5.527 5.006">
                                <path id="FM_24_MoBtop_dot_i_shadow_space_website" d="M -1.610737085342407 0 C -3.292033195495605 0 -4.392000198364258 1.079702377319336 -4.392000198364258 2.505163192749023 C -4.392000198364258 3.902759790420532 -3.323695659637451 5.005893707275391 -1.675329208374023 5.005893707275391 L -1.642399907112122 5.005893707275391 C 0.06929254531860352 5.005893707275391 1.135063052177429 3.898960590362549 1.135063052177429 2.50072979927063 C 1.10213315486908 1.077169299125671 0.06929254531860352 0 -1.610737085342407 0">
                                </path>
                            </svg>
                        </div>
                    </div>:""}
			{props.data.instagramUrl?	
                    <div title="Instagram" id="FM_24_MoBInsta_grp_shadow_space_website">
                        <svg class="FM_24_MoBshadow_space_website_7">
                            <ellipse id="FM_24_MoBshadow_space_website_7" rx="24" ry="24" cx="24" cy="24">
                            </ellipse>
                        </svg>
				<a href={props.data.instagramUrl} target="_blank">
                        <img id="FM_24_MoBinstagramshadow_space_website_" src="./Themes/FlowMasters/instagramshadow_space_website_.png" srcset="./Themes/FlowMasters/instagramshadow_space_website_.png 1x" />
                            
                        </a>
                    </div>:""}
			{props.data.whatsAppNumber?
                    <div title="WhatsApp" id="FM_24_MoBwhatsapp_grp_shadow_space_webs">
                        <svg class="FM_24_MoBmed_shadow_space_website_7_cf">
                            <ellipse id="FM_24_MoBmed_shadow_space_website_7_cf" rx="24" ry="24" cx="24" cy="24">
                            </ellipse>
                        </svg>
                        <a href={"https://api.whatsapp.com/send?phone="+props.data.whatsAppNumber.substring(props.data.whatsAppNumber.length-10)} target="_blank">
				<img id="FM_24_MoBwhatsapp_lbl_shadow_space_webs" src="./Themes/FlowMasters/whatsapp_lbl_shadow_space_webs.png" srcset="./Themes/FlowMasters/whatsapp_lbl_shadow_space_webs.png 1x" />
                          </a>  
                    </div>:""}
                </div>
                <div id="FM_24_MoBn_234567890_mobile_number_shad">
                    <span>{props.data.businessPhone}</span>
                </div>
                <div id="FM_24_MoBaffanghanioperatelive_email_sh">
                    <span>{props.data.businessEmail}</span>
                </div>
                <div id="FM_24_MoBaddress_med_shadow_space_websi">
                    <span>{props.data.businessAddress}</span>
                </div>
                <img id="FM_24_MoBlocation_img_shadow_space_webs" src="./Themes/FlowMasters/location_img_shadow_space_webs.png" srcset="./Themes/FlowMasters/location_img_shadow_space_webs.png 1x" />
                    
                <img id="FM_24_MoBemail_address_shadow_space_web" src="./Themes/FlowMasters/email_address_shadow_space_web.png" srcset="./Themes/FlowMasters/email_address_shadow_space_web.png 1x" />
                    
                <img id="FM_24_MoBphone_number_shadow_space_webs" src="./Themes/FlowMasters/phone_number_shadow_space_webs.png" srcset="./Themes/FlowMasters/phone_number_shadow_space_webs.png 1x" />
                    
                <div id="FM_24_MoBn_Copyright_Operate_Live_OPC_P">
                    <span>© Copyright Operate Live (OPC) Private Limited. <br/>All Rights Reserved</span>
                </div>
            </div>
            <div id="FM_24_MoBVisit_Us_">
                <span>Visit Us !!</span>
            </div>
            <iframe src={"https://maps.google.com/maps?width=100%25&height=600&hl=en&q="+((props.data.mapLatitude && (props.data.mapLatitude.toString()).length > 0)?props.data.mapLatitude.toString():"13.027696798394835")+","+((props.data.mapLongitude && (props.data.mapLongitude.toString()).length > 0)?props.data.mapLongitude.toString():"77.61844225211368")+"&t=&z=20&ie=UTF8&iwloc=B&output=embed&embedded=true;"} width="600" height="450" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" class="FM_24_MoBRectangle_735">
                <rect id="FM_24_MoBRectangle_735" rx="0" ry="0" x="0" y="0" width="341" height="222">
                </rect>
            </iframe>
        </div>
    </div>
  )
}

export default FlowMastersMob